/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Categories_CreatedInputs */

const en_admin_categories_created = /** @type {(inputs: Admin_Categories_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Category created`)
};

/**
* | output |
* | --- |
* | "Category created" |
*
* @param {Admin_Categories_CreatedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_categories_created = /** @type {((inputs?: Admin_Categories_CreatedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Categories_CreatedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_categories_created(inputs)
});
export { admin_categories_created as "admin.categories.created" }